import { render, staticRenderFns } from "./tag_navigator.html?vue&type=template&id=d1fc078e&"
import script from "./tag_navigator.ts?vue&type=script&lang=js&"
export * from "./tag_navigator.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports